import { render, staticRenderFns } from "./AppSoundButton.vue?vue&type=template&id=6b2d4258&scoped=true&"
import script from "./AppSoundButton.vue?vue&type=script&lang=js&"
export * from "./AppSoundButton.vue?vue&type=script&lang=js&"
import style0 from "./AppSoundButton.vue?vue&type=style&index=0&id=6b2d4258&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b2d4258",
  null
  
)

export default component.exports